<!-- src/components/MarkdownViewer.vue -->
<template>
  <div v-html="compiledMarkdown" class="markdown-content"></div>
</template>

<script>
import { marked } from 'marked';

import DOMPurify from 'dompurify'

export default {
  name: 'MarkdownViewer',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    compiledMarkdown() {
      if (!this.content) return ''
      
      // 配置 marked
      marked.setOptions({
        breaks: true,     // 识别换行符
        gfm: true,        // GitHub风格
        headerIds: true,  // 生成标题ID
        langPrefix: 'language-'
      })
      
      // 转换并净化
      const rawHtml = marked(this.content)
      return DOMPurify.sanitize(rawHtml)
    }
  }
}
</script>

<style>
.markdown-content {
  line-height: 1.6;
  word-wrap: break-word;
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3 {
  margin: 1.5em 0 0.5em 0;
  font-weight: 600;
}

.markdown-content h1 { font-size: 2em; }
.markdown-content h2 { font-size: 1.5em; border-bottom: 1px solid #eee; padding-bottom: 0.3em; }
.markdown-content h3 { font-size: 1.25em; }

.markdown-content p { margin: 1em 0; }
.markdown-content ul { padding-left: 2em; margin: 1em 0; }
.markdown-content li { margin: 0.5em 0; }
.markdown-content strong { font-weight: bold; }
.markdown-content em { font-style: italic; }
</style>